import styled from 'styled-components';
import {rem} from '@/styles/theme';
import ChevronRight from '@/assets/icons/chevronRight.svg';
import ChevronLeft from '@/assets/icons/chevronLeft.svg';
import ChevronUp from '@/assets/icons/chevronUp.svg';
import ChevronDown from '@/assets/icons/chevronDown.svg';
import VerticalDivider from '@/assets/icons/verticalDivider.svg';
import Information from '@/assets/icons/information.svg';

interface IIconProps {
  theme?: any;
  width?: number;
  height?: number;
  color: string;
}

const svgStyles = ({ width = 24, height, theme, color = 'gray-500' }: IIconProps) => {
  return `
    width: ${rem(width)};
    ${height && rem(height)};
    & path {
      fill: ${theme.color[color]};
    }
  `;
};

export const IconChevronRight = styled(ChevronRight)<IIconProps>`
  ${(props) => svgStyles(props)}
`;
export const IconChevronLeft = styled(ChevronLeft)<IIconProps>`
  ${(props) => svgStyles(props)}
`;
export const IconChevronUp = styled(ChevronUp)<IIconProps>`
  ${(props) => svgStyles(props)}
`;
export const IconChevronDown = styled(ChevronDown)<IIconProps>`
  ${(props) => svgStyles(props)}
`;

export const IconVerticalDivider = styled(VerticalDivider)<IIconProps>`
  ${(props) => svgStyles(props)};
`;
export const IconInformation = styled(Information)<IIconProps>`
  ${(props) => svgStyles(props)};
`;

